import { ensureBasicSwiper } from "barcelo-shared/swiper-runtime";
import { waitForStableLayout } from "../../../../../utils/rendering";

const launchersContainer = {
  props: {
    dynamicClass: ".launchers-container.dynamicLoading",
    className: "launchers-container",
  },

  init: async function () {
    const stylesReady = bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-launchersContainer.css", this.props.dynamicClass);

    const parentElement = Array.from(document.getElementsByClassName(this.props.className));
    if (!parentElement.length) {
      return;
    }

    await stylesReady;
    await waitForStableLayout();

    parentElement.forEach((element) => {
      let swiperInstance = null;
      let swiperLoading = false;
      const swiperElement = element.querySelector(".swiper");
      const mobileViewport = window.matchMedia("(max-width: 1024px)");
      const canObserveSize = typeof window.ResizeObserver === "function";
      const isVisible = () => !canObserveSize || (swiperElement.getClientRects().length > 0 && swiperElement.clientWidth > 0);

      const initSwiper = async () => {
        if (!swiperElement || !mobileViewport.matches || !isVisible() || swiperInstance || swiperLoading) {
          return;
        }

        swiperLoading = true;

        try {
          const SwiperConstructor = await ensureBasicSwiper();

          if (!swiperElement.isConnected || !mobileViewport.matches || !isVisible() || swiperInstance) {
            return;
          }

          swiperInstance = new SwiperConstructor(swiperElement, {
            slidesPerView: 2.5,
            freeMode: false,
            loop: false,
            spaceBetween: 16,
          });
        } catch (error) {
          console.error("Launchers container Swiper init error:", error);
        } finally {
          swiperLoading = false;
        }
      };

      const destroySwiper = () => {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      };

      const syncSwiper = () => {
        if (mobileViewport.matches) {
          initSwiper();
        } else {
          destroySwiper();
        }
      };

      syncSwiper();
      if (typeof mobileViewport.addEventListener === "function") {
        mobileViewport.addEventListener("change", syncSwiper);
      } else {
        mobileViewport.addListener(syncSwiper);
      }

      if (swiperElement && canObserveSize) {
        const resizeObserver = new window.ResizeObserver(syncSwiper);
        resizeObserver.observe(swiperElement);
      }
    });
  },
};

export default launchersContainer;
